import {RuntimeValue} from "./RuntimeValue";
import {RuntimeValueType} from "./RuntimeValueType";

export class RuntimeString implements RuntimeValue {
	readonly type: RuntimeValueType = "string";
	readonly value: string;
	
	constructor(value: string) {
		this.value = value;
	}
	
	asString(): string {
		return this.value;
	}
	
	asBoolean(): boolean {
		return this.value.toLowerCase() === "true" || this.value === "1";
	}
	
	asNumber(): number {
		return Number(this.value);
	}
}
